export const forwardRef =
  <T extends HTMLElement>(toRef?: React.ForwardedRef<T>) =>
  (fromRef: T) => {
    if (!toRef) {
      return;
    }
    if (typeof toRef === "function") {
      toRef(fromRef);
    } else {
      toRef.current = fromRef;
    }
  };
